import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Checkbox, Progress, Radio } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM,
} from "../../../../../../constants/Define";
import { capitalizeFirstLetter, checkUndefine, formatMoney } from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import { toArray } from "lodash";
import Input from "../../../../common/component/Input";
import TextArea from "../../../../common/component/TextArea";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import { formatPercentValue } from "../../../../../../utils/commonUtils";
import UnionBankCreateFormSection from "./UnionBankCreateFormSection";
import { PaymentCampaign } from "../../../../../../models/Campaign";
const defaultCollapseKey = "paymentCampaignTitleSection";

function PaymentCampaignTitleSection(props) {
  const { campaign, createType, validation, action, banks, onChange, setCampaign, onUploadFile, getPromotionBanks, getSupplierAll, supplierState } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();
  const [reloadBankList, setReloadBankList] = useState(false);
  const supplierOptions = supplierState.supplierAll || [];
  const isSkuProductType = createType
    ? createType.id === CAMPAIGN_ENUM.CREATE_TYPE.SKU.id
    : (campaign.productType || []).includes(CAMPAIGN_ENUM.PRODUCT_TYPE.SKU.value);
  const paymentCampaign = campaign.paymentCampaign || {};
  const bankType = paymentCampaign.bankType || CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.ONEPAY.id;
  const isVptBank = bankType === CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.VPT.id;
  const paymentCampaignType = campaign.isPaymentCampaign ? bankType : "NONE";
  const totalBudget = Number(paymentCampaign.totalBudget);
  const budgetUsed = Number(paymentCampaign.budgetUsed) || 0;
  const budgetPercent = totalBudget > 0
    ? Math.min(Math.round((budgetUsed / totalBudget) * 100), 100)
    : 0;
  const isPercentBankDiscount = paymentCampaign.bankDiscountType ===
    CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id;

  const getPaymentCampaign = () => {
    if (!campaign.paymentCampaign) {
      campaign.paymentCampaign = {};
    }
    return campaign.paymentCampaign;
  };

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const onChangeTypePaymentCampaign = value => {
    if (value === "NONE") {
      campaign.isPaymentCampaign = false;
    } else {
      campaign.isPaymentCampaign = true;
      if (bankType !== value) {
        campaign.paymentCampaign = new PaymentCampaign({ bankType: value });
      } else {
        getPaymentCampaign().bankType = value;
      }
    }
    setCampaign(campaign);
  };

  const onChangePaymentCampaign = (fieldName, value) => {
    getPaymentCampaign()[fieldName] = value;
    setCampaign(campaign);
  };

  const onChangeBank = bankCode => {
    const bank = banks.find(({ code }) => code === bankCode);
    if (!bank) return;
    const currentPaymentCampaign = getPaymentCampaign();
    currentPaymentCampaign.bankCode = bank.code;
    currentPaymentCampaign.bankTitle = bank.detail.title;
    currentPaymentCampaign.bankLogo = bank.detail.logo;
    if (!isVptBank) {
      currentPaymentCampaign.bankGateway = bank.gateway;
      currentPaymentCampaign.bankPaymentMethod = bank.detail.paymentMethod;
    }
    setCampaign(campaign);
  };

  const onChangeBankDiscountValue = value => {
    const currentPaymentCampaign = getPaymentCampaign();
    currentPaymentCampaign.bankDiscountValue = formatPercentValue(
      value,
      currentPaymentCampaign.bankDiscountType ===
        CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id
        ? 100
        : null
    );
    setCampaign(campaign);
  };

  const onChangeBankContributionPercent = value => {
    onChangePaymentCampaign(
      "bankContributionPercent",
      value === "" ? null : formatPercentValue(value, 100)
    );
  };

  const onChangeBankMaxDiscountValue = value => {
    const nextValue = Number(value);
    onChangePaymentCampaign(
      "bankMaxDiscountValue",
      value === "" || Number.isNaN(nextValue) ? 0 : nextValue
    );
  };

  const onChangeBankDiscountType = type => {
    const currentPaymentCampaign = getPaymentCampaign();
    currentPaymentCampaign.bankDiscountType = type;
    currentPaymentCampaign.bankDiscountValue = formatPercentValue(
      currentPaymentCampaign.bankDiscountValue,
      type === CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id ? 100 : null
    );
    if (type !== CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.PERCENT.id) {
      currentPaymentCampaign.bankMaxDiscountValue = 0;
    }
    setCampaign(campaign);
  };

  const getApplyForSupplierCodes = () => {
    const applyForSupplierCodes = paymentCampaign.applyForSupplierCodes;
    if (Array.isArray(applyForSupplierCodes)) {
      return applyForSupplierCodes;
    }
    if (typeof applyForSupplierCodes === "string" && applyForSupplierCodes) {
      return applyForSupplierCodes.split(",").map(item => item.trim()).filter(item => item);
    }
    return [];
  };

  useEffect(() => {
    const hasError = validation && Object.keys(validation).some(key => [
      "refCode",
      "bankTitle",
      "bankDiscountType",
      "bankDiscountValue",
      "bankContributionPercent",
      "contributionType",
      "bankMaxDiscountValue",
      "applyForPaymentMethods",
      "minOrderValue",
      "totalBudget"
    ].includes(key))
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation])

  useEffect(() => {
    getPromotionBanks();
  }, [getPromotionBanks, reloadBankList])

  useEffect(() => {
    if (campaign.isPaymentCampaign && isSkuProductType) {
      getSupplierAll({ productType: 7 });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign.isPaymentCampaign, isSkuProductType])

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.paymentCampaignTitle")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent>
              <Radio.Group
                value={paymentCampaignType}
                onChange={e => onChangeTypePaymentCampaign(e.target.value)}
              >
                <Radio value="NONE" className="mr-3">
                  {t("item.campaign.optionNo")}
                </Radio>
                <Radio value={CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.ONEPAY.id} className="mr-3">
                  Onepay
                </Radio>
                <Radio value={CAMPAIGN_ENUM.PAYMENT_BANK_TYPE.VPT.id} className="mr-3">
                  VPT
                </Radio>
              </Radio.Group>
            </FormWrapperInputComponent>
          </Wrapper>
          {campaign.isPaymentCampaign && (
            <>
              {!isVptBank && <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={paymentCampaign.refCode}
                  validation={validation.refCode}
                  labelTitle={t(`item.campaign.paymentCampaign.refCode`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    name="paymentCampaign.refCode"
                    onChange={e =>
                      onChangePaymentCampaign("refCode", e.target.value)
                    }
                    value={
                      paymentCampaign.refCode
                        ? paymentCampaign.refCode
                        : ""
                    }
                  />
                </FormWrapperInputComponent>
              </Wrapper>}
              <Wrapper className="col-md-6 bank-selection-block">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={paymentCampaign.bankTitle}
                  validation={validation.bankTitle}
                  labelTitle={t(`item.campaign.paymentCampaign.selectBank`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <UnionBankCreateFormSection setReloadBankList={setReloadBankList} onChange={onChange} onUploadFile={onUploadFile} />
                  <AntSelect
                    className="select-types"
                    showArrow
                    value={paymentCampaign.bankCode}
                    onChange={bank => onChangeBank(bank)}
                    style={{
                      width: "100%"
                    }}
                  >
                    {banks.map(bank => (
                      <AntOption key={bank.code} value={bank.code}>
                        {
                          <img
                            src={bank.detail.logo}
                            height="25px"
                            class="mr-1"
                          ></img>
                        }
                        {bank.detail.title}
                      </AntOption>
                    ))}
                  </AntSelect>
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-12">
                <Wrapper className="payment-budget-summary">
                  <div className="payment-budget-label">
                    {t("item.campaign.paymentCampaign.budgetUsed")}
                  </div>
                  <div className="payment-budget-value">
                    <strong>{formatMoney(budgetUsed)}</strong>
                    <span>
                      /{paymentCampaign.totalBudget === null
                        ? t("item.campaign.paymentCampaign.unlimited")
                        : formatMoney(totalBudget || 0)}
                    </span>
                  </div>
                  {paymentCampaign.totalBudget !== null && (
                    <Progress percent={budgetPercent} strokeColor="#4a90e2" />
                  )}
                </Wrapper>
              </Wrapper>
              {isVptBank && (
                <>
                  <Wrapper className="col-md-12">
                    <FormWrapperInputComponent
                      isRequired={true}
                      isValidation={true}
                      dataValidation={paymentCampaign.applyForPaymentMethods}
                      validation={validation.applyForPaymentMethods}
                      labelTitle={t("item.campaign.paymentCampaign.applyForPaymentMethods")}
                      visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                      <div className="payment-method-options">
                        <Checkbox.Group
                          value={paymentCampaign.applyForPaymentMethods}
                          onChange={methods => onChangePaymentCampaign("applyForPaymentMethods", methods)}
                        >
                          {toArray(CAMPAIGN_ENUM.PAYMENT_METHOD).map(method => (
                            <Checkbox key={method.id} value={method.id} className="mr-3">
                              {method.label}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      </div>
                      <div className="payment-field-hint">
                        {t("item.campaign.paymentCampaign.paymentMethodsHint")}
                      </div>
                    </FormWrapperInputComponent>
                  </Wrapper>
                </>
              )}
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={paymentCampaign.bankDiscountType}
                  messageBelowInput={true}
                  className="with-fix with-currency-suffix"
                  validation={validation.bankDiscountType || validation.bankDiscountValue}
                  labelTitle={t(`item.campaign.paymentCampaign.discountValue`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Wrapper className="row">
                    <Wrapper className="col-md-6">
                      <AntSelect
                        className="select-types"
                        showArrow
                        placeholder={capitalizeFirstLetter(
                          (
                            t("placeHolderForm.select") +
                            " " +
                            t("item.campaign.discountType")
                          ).toLowerCase()
                        )}
                        value={paymentCampaign.bankDiscountType}
                        onChange={type => {
                          onChangeBankDiscountType(type);
                        }}
                        style={{
                          width: "100%"
                        }}
                      >
                        {toArray(CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE).map(
                          item =>
                            !item.hide && (
                              <AntOption
                                key={item.id}
                                value={item.id}
                                disabled={item.disabled}
                              >
                                {t(`item.campaign.discountTypes.${item.key}`)}
                              </AntOption>
                            )
                        )}
                      </AntSelect>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                      <Input
                        type="currency"
                        nullable={true}
                        autoComplete="off"
                        suffix={
                          paymentCampaign.bankDiscountType ===
                          CAMPAIGN_ENUM.BANK_DISCOUNT_TYPE.AMOUNT.id
                            ? t(`currency`)
                            : isPercentBankDiscount
                            ? "%"
                            : undefined
                        }
                        className="form-control"
                        name="paymentCampaign.bankDiscountValue"
                        onChange={e =>
                          onChangeBankDiscountValue(e.target.value)
                        }
                        value={paymentCampaign.bankDiscountValue}
                      />
                    </Wrapper>
                  </Wrapper>
                </FormWrapperInputComponent>
              </Wrapper>
              {isVptBank && (
                <>
                  {isPercentBankDiscount && (
                    <Wrapper className="col-md-6">
                      <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={paymentCampaign.bankMaxDiscountValue}
                        validation={validation.bankMaxDiscountValue}
                        className="with-fix with-currency-suffix"
                        labelTitle={t("item.campaign.paymentCampaign.bankMaxDiscountValue")}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                      >
                        <Input
                          type="currency"
                          nullable={true}
                          autoComplete="off"
                          suffix={t("currency")}
                          className="form-control"
                          name="paymentCampaign.bankMaxDiscountValue"
                          onChange={e => onChangeBankMaxDiscountValue(e.target.value)}
                          value={checkUndefine(paymentCampaign.bankMaxDiscountValue)}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>
                  )}
                  <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                      isValidation={true}
                      dataValidation={paymentCampaign.minOrderValue}
                      validation={validation.minOrderValue}
                      className="with-fix with-currency-suffix"
                      labelTitle={t("item.campaign.paymentCampaign.minOrderValue")}
                      visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                      <Input
                        type="currency"
                        autoComplete="off"
                        suffix={t("currency")}
                        className="form-control"
                        name="paymentCampaign.minOrderValue"
                        onChange={e => onChangePaymentCampaign("minOrderValue", e.target.value)}
                        value={paymentCampaign.minOrderValue}
                      />
                    </FormWrapperInputComponent>
                  </Wrapper>
                </>
              )}
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  isValidation={true}
                  dataValidation={paymentCampaign.totalBudget}
                  validation={validation.totalBudget}
                  className="with-fix with-currency-suffix"
                  labelTitle={t("item.campaign.paymentCampaign.totalBudget")}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    type="currency"
                    nullable={true}
                    autoComplete="off"
                    suffix={t("currency")}
                    className="form-control"
                    name="paymentCampaign.totalBudget"
                    onChange={e => onChangePaymentCampaign(
                      "totalBudget",
                      e.target.value === "" ? null : e.target.value
                    )}
                    value={paymentCampaign.totalBudget}
                  />
                  <div className="payment-field-hint">
                    {t("item.campaign.paymentCampaign.totalBudgetHint")}
                  </div>
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  labelTitle={t("item.campaign.paymentCampaign.allowMultiPromotion")}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <AntSelect
                    className="select-types"
                    showArrow
                    value={paymentCampaign.allowMultiPromotion ? "true" : "false"}
                    onChange={value => onChangePaymentCampaign("allowMultiPromotion", value === "true")}
                    style={{ width: "100%" }}
                  >
                    <AntOption value="true">{t("item.campaign.optionYes")}</AntOption>
                    <AntOption value="false">{t("item.campaign.optionNo")}</AntOption>
                  </AntSelect>
                </FormWrapperInputComponent>
              </Wrapper>
              {isSkuProductType && (
                <Wrapper className="col-md-6">
                  <FormWrapperInputComponent
                    labelTitle="Lựa chọn nhà cung cấp"
                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  >
                    <AntSelect
                      className="select-types"
                      showArrow
                      mode="multiple"
                      placeholder="Lựa chọn nhà cung cấp"
                      value={getApplyForSupplierCodes()}
                      onChange={supplierCodes =>
                        onChangePaymentCampaign("applyForSupplierCodes", supplierCodes)
                      }
                      loading={supplierState.isFetching}
                      style={{
                        width: "100%"
                      }}
                    >
                      {(supplierOptions || []).filter(supplier => supplier && supplier.code).map(supplier => (
                        <AntOption key={supplier.code} value={supplier.code}>
                          {supplier.supplierName}
                        </AntOption>
                      ))}
                    </AntSelect>
                  </FormWrapperInputComponent>
                </Wrapper>
              )}
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  labelTitle={t(`item.campaign.paymentCampaign.title`)}
                >
                  <Input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    name="paymentCampaign.title"
                    onChange={e =>
                      onChangePaymentCampaign("title", e.target.value)
                    }
                    value={
                      paymentCampaign.title
                        ? paymentCampaign.title
                        : ""
                    }
                  />
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  labelTitle={t(`item.campaign.paymentCampaign.description`)}
                >
                  <TextArea
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    name="paymentCampaign.description"
                    onChange={e =>
                      onChangePaymentCampaign("description", e.target.value)
                    }
                    value={
                      paymentCampaign.description
                        ? paymentCampaign.description
                        : ""
                    }
                  />
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  labelTitle={t(`item.campaign.paymentCampaign.tooltip`)}
                >
                  <TextArea
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    name="paymentCampaign.tooltip"
                    onChange={e =>
                      onChangePaymentCampaign("tooltip", e.target.value)
                    }
                    value={
                      paymentCampaign.tooltip
                        ? paymentCampaign.tooltip
                        : ""
                    }
                  />
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={campaign.paymentCampaign.bankContributionPercent}
                  validation={validation.bankContributionPercent}
                  className="with-fix with-currency-suffix"
                  labelTitle={t("item.campaign.paymentCampaign.bankContributionPercent")}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    type="currency"
                    nullable={true}
                    autoComplete="off"
                    suffix="%"
                    className="form-control"
                    name="paymentCampaign.bankContributionPercent"
                    onChange={e => onChangeBankContributionPercent(e.target.value)}
                    value={campaign.paymentCampaign.bankContributionPercent}
                  />
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-6">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={campaign.paymentCampaign.contributionType}
                  validation={validation.contributionType}
                  labelTitle={t("item.campaign.paymentCampaign.contributionType")}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <div className="mt-2">
                    <Radio.Group
                      value={campaign.paymentCampaign.contributionType}
                      onChange={e => onChangePaymentCampaign("contributionType", e.target.value)}
                    >
                      {toArray(CAMPAIGN_ENUM.CONTRIBUTION_TYPE).map(type => (
                        <Radio key={type.id} value={type.id} className="mr-3">
                          {type.label}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </div>
                </FormWrapperInputComponent>
              </Wrapper>
            </>
          )}
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

PaymentCampaignTitleSection.propTypes = {
  campaign: PropTypes.object,
  createType: PropTypes.object,
  validation: PropTypes.object,
  action: PropTypes.string,
  banks: PropTypes.arrayOf(PropTypes.any),
  supplierState: PropTypes.object,
  onChange: PropTypes.func,
  setCampaign: PropTypes.func,
  getSupplierAll: PropTypes.func,
  getPromotionBanks: PropTypes.func
};

PaymentCampaignTitleSection.defaultProps = {
  campaign: {},
  validation: {},
  action: "",
  banks: [],
  supplierState: {},
  onChange: () => {},
  setCampaign: () => {},
  getSupplierAll: () => {},
  getPromotionBanks: () => {}
};

export default PaymentCampaignTitleSection;
